import React from 'react';
import cayConImg from '../assets/ImageSliderDetail/IMG_4341.JPG';
import cayConImg1 from '../assets/ImageSliderDetail/IMG_4344.JPG';

const IntroductionSection = () => {
  // Placeholder image URL since we can't import the original
  const placeholderImage = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%23d1d5db'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='16' fill='%23374151' text-anchor='middle' dy='.3em'%3EGreenGarden%3C/text%3E%3C/svg%3E";

  return (
    <div className="bg-gradient-to-br from-white via-[#eef5f0] to-white min-h-screen p-8 animate-fadeIn font-sans relative" style={{ fontFamily: 'Inter, Roboto, Arial, Helvetica, sans-serif' }}>
      {/* Icon động ngoài khung */}
      <div className="hidden md:block absolute -top-8 -right-8 z-30 animate-bounce">
        <span className="text-6xl">🌱</span>
      </div>
      <div className="max-w-7xl mx-auto bg-white rounded-xl shadow-lg border-2 border-[#669966] hover:border-[#4d7a4d] transition-all duration-500 hover:shadow-2xl overflow-hidden group relative">
        <div className="p-16">
          {/* Hero Section */}
          <div className="mb-12 animate-slideDown">
            <div className="flex items-center gap-8 flex-col md:flex-row">
              {/* Left Text */}
              <div className="flex-1 group">
                <h1 className="text-5xl font-bold text-gray-800 leading-tight mb-8 group-hover:text-[#2e402e] transition-colors duration-300 font-sans">
                  Lucendi — Nơi Ánh Sáng Vũ Điệu Cùng Hương Thơm<br />
                  <span className="block text-gray-600 text-lg font-normal leading-relaxed mt-6 font-sans">
                    Chào mừng bạn đến với Lucendi – cánh cửa thần tiên dẫn vào một thế giới nơi hương thơm kể những câu chuyện và ánh sáng dệt nên những giấc mơ.<br/>
                    Ánh lửa dịu dàng tan chảy bóng đêm, xoa dịu những ồn ào của thế giới bên ngoài.<br/>
                    Mỗi hũ nến Lucendi là một tác phẩm nghệ thuật được đổ khuôn bằng sự say mê và những nguyên liệu tinh túy nhất, nhằm biến không gian sống của bạn thành một chốn nghỉ ngơi sang trọng, một nơi trú ẩn của cảm xúc.
                  </span>
                </h1>
              </div>

              {/* Right Card */}
              <div className="w-[420px] h-full flex flex-col justify-center">
                <img
                  src={cayConImg}
                  alt="GreenGarden"
                  className="w-full object-cover rounded-lg shadow-lg transition-transform transition-shadow duration-500 hover:scale-105 hover:shadow-2xl animate-fadeInImg"
                  style={{ minHeight: 400, maxHeight: 600 }}
                />
              </div>
            </div>
          </div>

          {/* Pick of the Week Section */}
          <div className="mb-16 animate-slideUp">
            <div className="flex items-start gap-8 flex-col md:flex-row">
              {/* Left Video Card */}
              <div className="w-[420px] h-full flex flex-col justify-center">
                <img
                  src={cayConImg1}
                  alt="GreenGarden"
                  className="w-full object-cover rounded-lg shadow-lg transition-transform transition-shadow duration-500 hover:scale-105 hover:shadow-2xl animate-fadeInImg"
                  style={{ minHeight: 400, maxHeight: 600 }}
                />
              </div>

              {/* Right Content */}
              <div className="flex-1">

                <h2 className="text-3xl font-bold text-gray-900 mb-6 hover:text-[#2e402e] transition-colors duration-300 font-sans">
                  Lucendi – Tên gọi vang vọng ý nghĩa của Ánh Sáng. Chúng tôi không chỉ bán nến, mà đang trao gửi những khoảnh khắc nhiệm màu<br />
                </h2>
                <p className="text-gray-700 text-lg font-normal leading-relaxed mb-8 font-sans">
                  <span className="font-medium text-[#2e402e]"></span> <br />
                  Hương thơm tinh tế vuốt ve khứu giác, đưa bạn du hành qua những cánh rừng mộng mơ, những vườn hoa lãng mạn, hay những kỷ niệm êm đềm nhất.<br />
                  <span className="font-medium text-[#2e402e]"></span><br />
                  Hãy thắp sáng Lucendi, hít thở sâu và để tâm hồn bạn được bay bổng cùng vũ điệu của ánh sáng và mùi hương!
                </p>
              </div>
            </div>
          </div>

          {/* Recipe Key */}
          
          {/* Recent Reader Favorites */}

        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.8s ease-out forwards;
        }
        .animate-slideDown {
          animation: slideDown 0.8s ease-out forwards;
        }
        .animate-slideUp {
          animation: slideUp 0.8s ease-out forwards;
          animation-delay: 0.2s;
        }
      `}</style>
    </div>
  );
};

export default IntroductionSection;